<div
    class="agpr-formField agpr-checkboxContainer"
>
    <div
        *ngIf="field.label"
        class="agpr-formField-label agpr-checkboxesContainer-heading"
    >
        {{ field.label | localize }}
    </div>
    <agpr-checkbox
        [id]="id + field.option.key"
        class="agpr-checkbox"
        [value]="field.option.key"
        [label]="field.option.label | localize"
        name="checkboxOptions"
        [binary]="field.binary"
        [(ngModel)]="value"
        (ngModelChange)="changes.emit($event)"
    >
    </agpr-checkbox>
</div>